const styles = theme => ({
  root: {
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 24,
  },
  photo: {
    marginTop: 12,
    width: '75%',
    height: '75%',
    position:'relative',
    [theme.breakpoints.up('sm')]: {
      marginTop: 30,
      width: '40%',
      height: '40%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
      width: '26%',
      height: '26%',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/GetStarted/components/Phone/styles.js